import * as Yup from "yup";

const hasAnyContactData = (dniContacto, telefonoContacto, mailContacto) => {
  const hasDni = dniContacto !== null && dniContacto !== undefined && dniContacto !== "";
  const hasTelefono = !!telefonoContacto?.toString().trim();
  const hasMail = !!mailContacto?.toString().trim();
  return hasDni || hasTelefono || hasMail;
};

export const validateResponsables = Yup.object({
  nombreApellidoContacto: Yup.string()
    .matches(/^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\s]+$/, {
      message: "Ingrese sólo letras y espacios",
      excludeEmptyString: true,
    })
    .max(50, "Máximo 50 caracteres")
    .test(
      "required-if-contact-data",
      "Nombre y Apellido es requerido si se ingresa DNI, teléfono o mail",
      function (value) {
        const { dniContacto, telefonoContacto, mailContacto } = this.parent || {};
        const hasContactData = hasAnyContactData(dniContacto, telefonoContacto, mailContacto);
        const hasName = !!value?.toString().trim();

        return !(hasContactData && !hasName);
      }
    ),
  dniContacto: Yup.number()
    .min(10000000, "Mínimo 8 dígitos")
    .max(99999999, "Máximo 8 dígitos")
    .integer("No ingrese caracteres especiales")
    .nullable()
    .typeError("Ingrese sólo números")
    .when('nombreApellidoContacto', {
      is: (nombreApellidoContacto) => nombreApellidoContacto && nombreApellidoContacto.trim().length > 0,
      then: (schema) => schema.required('DNI es requerido si se ingresa un contacto en la obra'),
      otherwise: (schema) => schema.optional()
    }),
  telefonoContacto: Yup.string()
    .matches(
      /^[0-9]*$/,
      "Solo se permiten números"
    )
    .max(50, "El número de teléfono debe tener como máximo 50 caracteres")
    .when('nombreApellidoContacto', {
      is: (nombreApellidoContacto) => nombreApellidoContacto && nombreApellidoContacto.trim().length > 0,
      then: (schema) => schema.required('Teléfono es requerido si se ingresa un contacto en la obra'),
      otherwise: (schema) => schema.optional()
    }),
  mailContacto: Yup.string()
    .max(255, "Máximo 255 caracteres")
    .matches(
      /@.*\.com/,
      "Ingrese una dirección de correo válida"
    )
    .email("Ingrese una dirección de correo válida")
    .optional(),
  responsableSeguridadHigiene: Yup.string().required("Campo obligatorio").nullable(),
});
